import { render, staticRenderFns } from "./shopee.vue?vue&type=template&id=27e94775"
import script from "./shopee.vue?vue&type=script&lang=js"
export * from "./shopee.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports